import Heading from "common/components/Typography/Heading/Heading";
import React from "react";
import { Link } from "react-router-dom";
import styles from './DashboardView.module.scss';
import MessageRenderer from "common/components/MessageRenderer/MessageRenderer";

export default function DashboardView(props){

    return <div className={styles.viewwrapper}>
        <div className={styles.messagewrapper}>
            <MessageRenderer keyCode="PROV_MSG003" />
        </div>
    </div>;


}